(function applyGroveBestsellersMode() {
  var cookieName = 'grove_bestsellers_mode';
  var maxAge = 60 * 60 * 24 * 30;
  var match = document.cookie.match(/(?:^|;\s*)grove_bestsellers_mode=([^;]+)/);
  var mode = match ? decodeURIComponent(match[1]) : '';

  if (mode !== 'bestselling' && mode !== 'stock') {
    mode = Math.random() < 0.5 ? 'bestselling' : 'stock';
    var cookie = cookieName + '=' + mode + '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax';
    if (location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  document.documentElement.setAttribute('data-grove-bestsellers-mode', mode);
})();
